import { createAsyncThunk } from "@reduxjs/toolkit";

// get State List
export const getStateAction = createAsyncThunk("getStateList",
    async (body) => {
        const response = await fetch(
            // `https://h2v0zqu6h5.execute-api.ap-south-1.amazonaws.com/prod/prod_bmi_get_rto?type=statename`,
            "https://52lku5p2bj.execute-api.ap-south-1.amazonaws.com/Prod/prod_brilljust_get_rto?type=statename",
            {
                method: "GET",
                headers: {
                    "Authorization": `${body?.token}`,
                    "Content-type": "application/json; charset=UTF-8",
                },
               
            }
        );
        return response.json();
    });

// get City List
export const getCityAction = createAsyncThunk(
    "getCityList",
    async (body) => {
        const response = await fetch(
            `https://52lku5p2bj.execute-api.ap-south-1.amazonaws.com/Prod/prod_brilljust_get_rto?type=city&statename=${body?.state}`,
            {
                method: "GET",
                headers: {
                    "Authorization": `${body?.token}`,
                    "Content-type": "application/json; charset=UTF-8",
                },
            }
        );
        return response.json();
    }
);